import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import injectionService from '../../axios/services/injectionService';
import SimpleCard from '../../components/templates/SimpleCard';
import { injectionActions } from '../../redux/actions/injectionActions';
import Form from './Form';


const CreateTab = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = (values) => {
    setIsLoading(true)
    injectionService.create(values)
      .then(() => dispatch(injectionActions.changeTab(0)))
      .catch(() => setIsLoading(false))
  }

  return (
    <SimpleCard loading={isLoading}>
      <p className="font-500 mb-12">Buat Injection</p>
      <hr />
      <Form onSubmit={onSubmit} />
    </SimpleCard>
  )
}

export default CreateTab
